import customerList from './customerList/customerList';
import jobNew from './jobNew/jobNew';
import jobTaskAllocation from './jobTaskAllocation/jobTaskAllocation';
import jobView from './jobView/jobView';
import jobsForCustomerView from './jobsForCustomerView/jobsForCustomerView';

const customerListConfig = {
    settings: {
        layout: {}
    },
    auth: ['admin', 'supervisor'],
    routes: [
        {
            path: '/crm/customerList',
            component: customerList
        }
    ]
};

const jobNewConfig = {
    settings: {
        layout: {}
    },
    auth: ['admin', 'supervisor'],
    routes: [
        {
            path: '/crm/jobNew',
            component: jobNew
        }
    ]
};

const jobTaskAllocationConfig = {
    settings: {
        layout: {}
    },
    auth: ['admin', 'supervisor'],
    routes: [
        {
            path: '/crm/jobTaskAllocation',
            component: jobTaskAllocation
        }
    ]
};

const jobViewConfig = {
    settings: {
        layout: {}
    },
    auth: ['admin', 'supervisor'],
    routes: [
        {
            path: '/crm/jobView',
            component: jobView
        }
    ]
};

const jobsForCustomerConfig = {
    settings: {
        layout: {}
    },
    auth: ['admin', 'supervisor'],
    routes: [
        {
            path: '/crm/jobsForCustomerView',
            component: jobsForCustomerView
        }
    ]
};

export const crmRouterConfigs = [

    customerListConfig,
    jobNewConfig,
    jobTaskAllocationConfig,
    jobViewConfig,
    jobsForCustomerConfig
];


// WEBPACK FOOTER //
// ./src/main/content/crm/crmRouterConfigs.js